import React, { useRef } from 'react';
import {
  Drawer,
} from 'antd';
import { Wrapper } from './style';
import { CloseIconDrawer } from '../../../screens/Home/styles';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';

type Props = {
  children: React.ReactNode,
  footer?: React.ReactNode,
  visibility: boolean,
  onClose: () => void
  height?: number
}
function StyledDrawer({
  children, visibility, footer, onClose, height,
}: Props) {
  const popoverContainerRef = useRef(null);

  const CloseIconComponent = (
    <CloseIconDrawer>
      {' '}
      <CloseIcon />
      {' '}
    </CloseIconDrawer>
  );

  const getContainer = () => popoverContainerRef.current as unknown as HTMLElement;

  return (
    <Wrapper ref={popoverContainerRef}>
      <Drawer
        placement="bottom"
        closable
        onClose={() => onClose()}
        visible={visibility}
        closeIcon={CloseIconComponent}
        key="bottom"
        className="trips-drawer"
        getContainer={getContainer()}
        footer={footer}
        height={height}
      >
        {children}
      </Drawer>
    </Wrapper>
  );
}

StyledDrawer.defaultProps = {
  height: 378,
  footer: null,
};

export default StyledDrawer;
